export const tiposRelacionamento = ["Cônjuge", "Sócio", "Procurador", "Familiar", 'Terceiro Autorizado'];
